module.exports = __webpack_public_path__ + "img/parokonnaya.0b94f205.jpg";